import { render, staticRenderFns } from "./TheOrganizationPhoneForm.vue?vue&type=template&id=7c901c22&"
import script from "./TheOrganizationPhoneForm.vue?vue&type=script&lang=js&"
export * from "./TheOrganizationPhoneForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports